import { ReactNode } from "react";

import { SectionCard } from "../../../../Manifests/sections/SectionCard";
import { SectionHeader } from "../../../../Manifests/sections/SectionHeader";

/**
 * A profile section as one of the drawer's gray section cards, so the four
 * profile sections read as part of the same set as Details, Shipments, and
 * Discrepancies rather than as a differently-styled block bolted underneath.
 */
export const ProfileSection = ({
  title,
  action,
  adornment,
  children,
}: {
  title: string;
  /** Right-aligned action, e.g. an edit button. */
  action?: ReactNode;
  /** Inline content immediately after the title, e.g. a status chip. */
  adornment?: ReactNode;
  children: ReactNode;
}) => (
  <SectionCard>
    <SectionHeader title={title} action={action}>
      {adornment}
    </SectionHeader>
    {children}
  </SectionCard>
);
